import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const usePredicateStoreUpdatePredicatePart = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const updatePredicatePart = useStore(store, (s) => s.updatePredicatePart);

    return updatePredicatePart;
};
